import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="px-5 md:px-10 pt-40 md:pt-56 pb-32">
      <p className="font-display text-[30vw] md:text-[16vw] leading-none text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.2)]">
        404
      </p>
      <h1 className="font-display text-5xl md:text-7xl leading-[0.95] mt-6">
        THIS PAGE DOES NOT EXIST.
      </h1>
      <p className="kicker mt-4">BUT THE RAVE CONTINUES.</p>
      <Link data-testid="notfound-home" to="/" className="btn-primary mt-12">
        BACK HOME
      </Link>
    </div>
  );
}
